import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import { LoadingSpinner } from './LoadingSpinner';
import { ROUTES } from '../../config/routes';

interface AuthGuardProps {
  children: React.ReactNode;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, isLoading, idToken, clearAuth } = useAuthStore();

  React.useEffect(() => {
    if (isAuthenticated && !idToken) {
      clearAuth();
    }
  }, [isAuthenticated, idToken, clearAuth]);

  if (isLoading) {
    return <LoadingSpinner fullPage message="認証情報を確認中..." />;
  }

  if (!isAuthenticated || !idToken) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

// 認証済みユーザーがアクセスできないページ用（ログイン、サインアップなど）
export const GuestGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated, isLoading, idToken } = useAuthStore();
  const location = useLocation();

  if (isLoading) {
    return <LoadingSpinner fullPage message="確認中..." />;
  }

  if (isAuthenticated && idToken) {
    // リダイレクト元があればそこへ、なければホームへ
    const from = (location.state as { from?: Location })?.from?.pathname || ROUTES.HOME;
    return <Navigate to={from} replace />;
  }

  return <>{children}</>;
};
